import React from "react";
type CutPlanProps = {
  className?: string;
  dark?: boolean;
};
function CutPlan({
  className = "",
  dark = false
}: CutPlanProps) {
  const stroke = dark ? "#F7F5F0" : "#17283B";
  return <svg aria-hidden="true" className={`pointer-events-none ${className}`} viewBox="0 0 640 220" fill="none" preserveAspectRatio="none" data-id="element-380" data-mp="2dios4pq9owe0">
      <g stroke={stroke} strokeOpacity=".14" strokeWidth="1" data-id="element-381" data-mp="2higweq8mogdk">
        <path d="M0 28H640M0 110H640M0 192H640" data-id="element-382" data-mp="2mjd7povb74t0" />
        <path d="M54 0V220M214 0V220M408 0V220M590 0V220" data-id="element-383" data-mp="2ripts7ecw7uj" />
        <path d="M54 44H214V172H54zM240 28h168v66H240zM240 116h96v76h-96zM360 116h178v76H360z" data-id="element-384" data-mp="2rh50sm7owwys" />
        {Array.from({
        length: 15
      }).map((_, index) => <path key={index} d={`M${74 + index * 32} 24v${index % 2 === 0 ? 8 : 4}`} data-id="element-385" data-mp="3192bzsyp7oxi" data-mpi={index} />)}
      </g>
      <g stroke="#EC6E30" strokeWidth="2" data-id="element-386" data-mp="35b5rqtsehfol">
        <path d="M224 104h-12V92M420 104h12V92M224 180h-12v12M420 180h12v12" data-id="element-387" data-mp="358b5cwpttksj" />
        <path d="M226 102h192v80H226z" strokeOpacity=".7" data-id="element-388" data-mp="3aa0hygsp66iq" />
      </g>
      <path d="M438 152l30 17-13 4 8 15-8 4-8-15-9 10z" fill="#EC6E30" data-id="element-389" data-mp="1sf22356lfekd" />
      <g fill={stroke} fillOpacity=".48" fontFamily="Inter, sans-serif" fontSize="9" data-id="element-390" data-mp="1od85b7ziquph">
        <text x="58" y="39" data-id="element-391" data-mp="1ofkvg8ffkbdm">1600</text>
        <text x="244" y="106" data-id="element-392" data-mp="1jdbzr4b6av7t">SELECTED PANEL · 720 × 600</text>
        <text x="544" y="187" data-id="element-393" data-mp="1jfyfvsc4qj1n">2400</text>
      </g>
    </svg>;
}
export { CutPlan };